var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRequestNot({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.00651 4.39201C2.00651 4.02382 2.30499 3.72534 2.67318 3.72534H13.3333C13.7015 3.72534 14 4.02382 14 4.39201V11.9415C14 12.6779 13.4031 13.2748 12.6667 13.2748H3.33333C2.59695 13.2748 2 12.6779 2 11.9415V4.60816C2 4.57641 2.00222 4.54518 2.00651 4.51462V4.39201ZM3.33333 5.87456V11.9415H12.6667V5.87478L9.41433 9.12712C8.63327 9.90819 7.36693 9.90819 6.5859 9.12712L3.33333 5.87456ZM4.38156 5.03707H11.6187L8.47155 8.18424C8.21122 8.44457 7.78908 8.44457 7.52875 8.18424L4.38156 5.03707Z",
    fill: "#8D8D8D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRequestNot);
export default __webpack_public_path__ + "static/media/request-not.dd2502c402624b52e8d67990a8508e21.svg";
export { ForwardRef as ReactComponent };